import ApiServices from '@/services/api'
import globalMixin from '@/mixins'
let that = globalMixin.methods

// --->>>>>>>>>>>>>>>   all Service Provider List api call   <<<<<<<<<<<<<<---
const SERVICE_PROVIDER_LIST = ({commit},data) => {
  return ApiServices.getServiceProvider(data)
    .then(response => {
      commit('getServiceProvider', response)
      // that.SUCCESS_TOAST_MSG(response.message)
    })
}

// --->>>>>>>>>>>>>>>   all Service Provider STATUS CHANGE List api call   <<<<<<<<<<<<<<---
const SERVICE_PROVIDER_STATUS_CHANGE = ({ commit }, data) => {
  return ApiServices.serviceProviderStatusChange(data)
    .then(response => {
      commit('serviceProviderStatus', response)
      // console.log("getServiceProvider=====", response)
      // that.SUCCESS_TOAST_MSG(response.message)
    })
}

// --->>>>>>>>>>>>>>>   Add Service Provider api call   <<<<<<<<<<<<<<---
const ADD_SERVICE_PROVIDER = ({commit}, data) => {
  return ApiServices.addServiceProvider(data)
    .then(response => {
      // commit('addServiceProvider', response)
      // console.log("addServiceProvider=====", response)
      that.SUCCESS_TOAST_MSG(response.message)
    })
}

// --->>>>>>>>>>>>>>>   Updae Service Provider api call   <<<<<<<<<<<<<<---
const UPDATE_SERVICE_PROVIDER = ({ commit }, data) => {
  return ApiServices.updateServiceProvider(data)
    .then(response => {
      // commit('updateServiceProvider', response)
      // console.log("updateServiceProvider=====", response)
      that.SUCCESS_TOAST_MSG(response.message)
    })
}
const MAIL_CHECKER_PROVIDER = ({ commit }, data) => {
  return ApiServices.mailChecker(data)
    .then(response => {
      // console.log("updateServiceProvider=====", response)
      that.SUCCESS_TOAST_MSG(response.message)
    })
}


export default {
  SERVICE_PROVIDER_LIST,
  SERVICE_PROVIDER_STATUS_CHANGE,
  ADD_SERVICE_PROVIDER,
  UPDATE_SERVICE_PROVIDER,
  MAIL_CHECKER_PROVIDER
}



// WEBPACK FOOTER //
// ./src/store/modules/serviceProvider/actions.js